import React, {Component} from "react";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";

import {connect} from "react-redux";
import {CurrencyDefinition} from "../http/protocol";
import Title from "../layout/Title";
import {t} from "../i18n";

import {setActiveCurrency} from "../user/UserActions";
import {getVisibleCurrencies} from "../selectors/user-selectors";


interface CurrencyButton {
    onClick: (currencyCode: string) => void;
    symbol?: string;
    name?: string;
    code?: string;
}

const CurrencyButton = (props: CurrencyButton) => {
    return (
        <div onClick={ () => {props.onClick(props.code != undefined ? props.code : "")} } className={"menu-button menu-button-enter-done"}>
            {props.symbol != undefined &&
                <i className={`currency-icon currency-icon-${props.code?.toLocaleLowerCase() ?? ""}`}></i>
            }
            {props.name != undefined && (<span className={"title"}>{props.name}</span>)}
        </div>
    )
}

interface Props {
    onClose: () => void;
}

interface State {
    animate: boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & Props;

export class ChangeCurrency extends Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);

        this.state = {
            animate: false
        }
    }

    handleClick = (currencyCode: string) => {
        if(this.props.setActiveCurrency != null) {
            this.props.setActiveCurrency(currencyCode);
        }

        this.props.onClose();
    }

    componentDidMount(): void {
        this.setState({animate: true});
    }

    render() {
        return(
            <div className={"menu"}>
                <Title animate={this.state.animate} title={t("payments.selectCurrency")} />
                <div className={"menuButtonWrapper"}>
                    {
                    this.props.currencies && this.props.currencies.length > 0
                        ? this.props.currencies.map((currency, index) => {
                            if(currency.visible) {
                                return <CurrencyButton
                                    key={index}
                                    onClick={this.handleClick}
                                    code={currency.code}
                                    symbol={currency.prefixSymbol}
                                    name={currency.name}/>
                            }
                        })
                        : null
                    }
                </div>
            </div>
        )
    }
}

interface PropsFromState {
    currencies?: Array<CurrencyDefinition>;
}

interface PropsFromDispatch {
    setActiveCurrency?: typeof setActiveCurrency;
}

const mapStateToProps = (app : AppState) => {
    return {
        currencies: getVisibleCurrencies(app)
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        setActiveCurrency : (currency:string)=>dispatch(setActiveCurrency(currency) as any)
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(ChangeCurrency);